import { createApi } from "@reduxjs/toolkit/query/react";
import {
  OrderDetails,
  OrdersResponse,
  OrderSummary,
  PaginationInfo,
} from "../../data/interfaces";
import { HttpMethod, ORDER, TagId, TagType } from "../../data/constants";
import { createBaseQuery } from "../helpers/baseQueryHelper";

const orderApi = createApi({
  reducerPath: ORDER.reducerPath,
  baseQuery: createBaseQuery(ORDER.baseUrl),
  tagTypes: ORDER.tagTypes,
  endpoints(builder) {
    return {
      fetchOrders: builder.query<OrdersResponse, void>({
        query: () => {
          return {
            url: "/restaurant",
            method: HttpMethod.GET,
          };
        },
        providesTags: () => [{ type: TagType.Order, id: TagId.LIST }],
      }),
      fetchPastOrders: builder.query<
        { orders: OrderSummary[]; paginationInfo: PaginationInfo },
        { page: number; perPage: number }
      >({
        query: ({ page = 1, perPage = 20 }) => {
          return {
            url: `/history?page=${page}&perPage=${perPage}`,
            method: HttpMethod.GET,
          };
        },
        providesTags: () => [{ type: TagType.Order, id: TagId.LIST_PAST }],
      }),
      fetchOrderDetails: builder.query<OrderDetails, string>({
        query: (orderId) => {
          return {
            url: "/restaurant/" + orderId,
            method: HttpMethod.GET,
          };
        },
        providesTags: (_result, _error, orderId) => [
          { type: TagType.Order, id: orderId },
        ],
      }),
      acceptOrder: builder.mutation<void, string>({
        query: (orderId) => ({
          url: `/${orderId}/accept`,
          method: HttpMethod.PUT,
        }),
        invalidatesTags: (_result, _error, orderId) => [
          { type: TagType.Order, id: TagId.LIST },
          { type: TagType.Order, id: orderId },
        ],
      }),
      makeOrderReady: builder.mutation<void, string>({
        query: (orderId) => ({
          url: `/${orderId}/ready`,
          method: HttpMethod.PUT,
        }),
        invalidatesTags: (_result, _error, orderId) => [
          { type: TagType.Order, id: TagId.LIST },
          { type: TagType.Order, id: orderId },
        ],
      }),
    };
  },
});

export const {
  useFetchOrdersQuery,
  useFetchOrderDetailsQuery,
  useFetchPastOrdersQuery,
  useAcceptOrderMutation,
  useMakeOrderReadyMutation,
} = orderApi;

export { orderApi };
